import { EmployeeCostSectionTypeDTO } from "src/models/employee-cost-section-type/employee-cost-section-type-dto";
import { BaseApiService } from "../base";
import { EmployeeCostSectionTypeSTO } from "src/models/employee-cost-section-type/employee-cost-section-type-sto";

export class EmployeeCostSectionTypeApiService extends BaseApiService<
  EmployeeCostSectionTypeDTO,
  EmployeeCostSectionTypeSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeCostSectionTypes",
      loadItemsPath: "/GetEmployeeCostSectionTypes",
      saveItemsPath: "/SaveEmployeeCostSectionTypes",
    });
  }
}
